import { Mail, Send, User, MessageSquare } from 'lucide-react';
import { useNewsletterForm, useContactForm } from '@/hooks/useFormHandlers';

function NewsletterForm() {
  const { email, setEmail, loading, submit } = useNewsletterForm();
  return (
    <div>
      <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4 flex items-center gap-2">
        <Mail className="w-4 h-4" /> Stay Connected
      </p>
      <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-4 tracking-tight">Newsletter</h2>
      <p className="text-[#a3b1c6] text-base leading-relaxed mb-8">
        Subscribe to receive the latest sitar music news, concert announcements, learning resources, and exclusive content delivered to your inbox.
      </p>
      <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3">
        <input
          data-testid="newsletter-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="flex-1 bg-[#0a1628] border border-[#1c2a3d] rounded-md px-4 py-3 text-[#fdfbf7] placeholder:text-[#a3b1c6]/50 focus:border-[#d4af37] focus:ring-1 focus:ring-[#d4af37] transition-all outline-none"
          required
        />
        <button
          data-testid="newsletter-subscribe-btn"
          type="submit"
          disabled={loading}
          className="bg-[#d4af37] text-[#0a1628] hover:bg-[#b49129] font-medium px-6 py-3 rounded-md transition-all duration-300 flex items-center justify-center gap-2 disabled:opacity-50"
        >
          {loading ? 'Subscribing...' : <><Send className="w-4 h-4" /> Subscribe</>}
        </button>
      </form>
    </div>
  );
}

const INPUT_CLASS = "w-full bg-[#0a1628] border border-[#1c2a3d] rounded-md py-3 text-[#fdfbf7] placeholder:text-[#a3b1c6]/50 focus:border-[#d4af37] focus:ring-1 focus:ring-[#d4af37] transition-all outline-none";

function ContactForm() {
  const { form, setField, loading, submit } = useContactForm();
  return (
    <div>
      <p className="text-sm uppercase tracking-[0.2em] text-[#d4af37] mb-4 flex items-center gap-2">
        <MessageSquare className="w-4 h-4" /> Get in Touch
      </p>
      <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl text-[#fdfbf7] mb-8 tracking-tight">Contact Us</h2>
      <form onSubmit={submit} className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="relative">
            <User className="absolute left-3 top-3.5 w-4 h-4 text-[#a3b1c6]/50" />
            <input data-testid="contact-name-input" type="text" value={form.name} onChange={(e) => setField('name', e.target.value)} placeholder="Your name" className={`${INPUT_CLASS} pl-10 pr-4`} required />
          </div>
          <div className="relative">
            <Mail className="absolute left-3 top-3.5 w-4 h-4 text-[#a3b1c6]/50" />
            <input data-testid="contact-email-input" type="email" value={form.email} onChange={(e) => setField('email', e.target.value)} placeholder="Your email" className={`${INPUT_CLASS} pl-10 pr-4`} required />
          </div>
        </div>
        <input data-testid="contact-subject-input" type="text" value={form.subject} onChange={(e) => setField('subject', e.target.value)} placeholder="Subject (optional)" className={`${INPUT_CLASS} px-4`} />
        <textarea data-testid="contact-message-input" value={form.message} onChange={(e) => setField('message', e.target.value)} placeholder="Your message" rows={4} className={`${INPUT_CLASS} px-4 resize-none`} required />
        <button data-testid="contact-submit-btn" type="submit" disabled={loading} className="bg-[#d4af37] text-[#0a1628] hover:bg-[#b49129] font-medium px-8 py-3 rounded-md transition-all duration-300 disabled:opacity-50">
          {loading ? 'Sending...' : 'Send Message'}
        </button>
      </form>
    </div>
  );
}

export default function NewsletterSection() {
  return (
    <section id="contact" data-testid="contact-section" className="py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16">
          <NewsletterForm />
          <ContactForm />
        </div>
      </div>
    </section>
  );
}
